import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { APP_VIDEOANGULAR_MODULE } from '../../utilities/packages/videogular.package';
import { SmallVideoPlayerComponent } from './small-video-player/small-video-player.component';
import { APP_PRIMENG_MODULE } from '../../utilities/packages/primeng.package';
import { SpriteSheetGeneratorComponent } from './sprite-sheet-generator/sprite-sheet-generator.component';


export const Module_Declarations=[SmallVideoPlayerComponent, SpriteSheetGeneratorComponent]

@NgModule({
  declarations: Module_Declarations,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, APP_VIDEOANGULAR_MODULE, APP_PRIMENG_MODULE],
  exports: Module_Declarations
})
export class SmallPlayerModule { }
